var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "!!raw-loader!../../../resources/appfragments/builtin.html", "client/appfragment/readonly"], function (require, exports, builtin_html_1, readonly_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BuiltinReadonlyAppFragmentStore = void 0;
    builtin_html_1 = __importDefault(builtin_html_1);
    readonly_1 = __importDefault(readonly_1);
    function createTemplate(html) {
        var el = document.createElement("template");
        el.innerHTML = html;
        return el.content;
    }
    class BuiltinReadonlyAppFragmentStore extends readonly_1.default {
        // documentPromise: Promise<HTMLElement>;
        constructor(options) {
            super(Object.assign({ el: createTemplate(builtin_html_1.default) }, options));
        }
        getByTypeAndName(appType, appName) {
            return super.getByTypeAndName(appType, appName);
        }
        findFirstByTypeAndNames(appType, appNames) {
            return super.findFirstByTypeAndNames(appType, appNames);
        }
    }
    exports.BuiltinReadonlyAppFragmentStore = BuiltinReadonlyAppFragmentStore;
});
